import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { problemPoints } from '../data/sections';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function ProblemSection() {
  return <section className="bg-mp-black py-16 md:py-24" data-id="element-223" data-mp="2vp6cwdfhom9a">
      <Container data-id="element-224" data-mp="39hcr3tz30j63">
        <div className="max-w-[700px]" data-id="element-225" data-mp="39guqkl5dzisd">
          <SectionTag tone="white" data-id="element-226" data-mp="39jyx3p6bqqm7">El punto de partida</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-227" data-mp="35fivw17no7db">
            Tu problema no es que no sepas pádel.
          </h2>
          <p className="mt-3 font-heading text-lg uppercase text-mp-lime md:text-xl" data-id="element-228" data-mp="3egpc096e7g61">
            Es todo el trabajo que ocurre antes de entrar en pista.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-229" data-mp="1k3hg0e6okyit">
          {problemPoints.map((point, i) => <motion.div key={point} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.35,
          ease: easeOut,
          delay: i % 4 * 0.04
        }} className="flex items-start gap-3 rounded-xl border border-mp-border bg-mp-card px-4 py-3.5" data-id="element-230" data-mp="je6cwrhly658" data-mpi={i}>
              <ClockIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-mp-lime" strokeWidth={2} data-id="element-231" data-mp="122jsdniniqdn" />
              <span className="text-sm text-mp-gray md:text-[15px]" data-id="element-232" data-mp="171mxf7ymswlm">{point}</span>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        ease: easeOut
      }} className="mx-auto mt-10 max-w-[650px] rounded-xl border border-mp-border bg-mp-dark px-6 py-5 text-center text-base leading-relaxed text-mp-white md:text-lg" data-id="element-233" data-mp="1bzodrl4oahte">
          Maestro en Pista convierte todo ese trabajo previo en un sistema organizado que puedes consultar cuando lo
          necesitas.
        </motion.p>
      </Container>
    </section>;
}